import { useCheckPermission } from './useUserRoles';
import { useAdminCheck } from './useAdminCheck';

/**
 * Project Tabs Permission Hooks
 * ✅ Non-Regression: Dedicated hooks for project tab access control
 * ✅ Namespace: Clear separation for project tabs permissions
 * ✅ Admin override: Admins always have access
 */

export const usePlanAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('PLAN_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

export const useResourceAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('RESOURCE_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

export const useExecuteAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('EXECUTE_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

export const useSubconsPageAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('SUBCONS_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

export const useAIAdvisorAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('AI_ADVISOR_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

/**
 * ✅ NEEDS TAB: Access control for Needs tab in project detail
 * Requires NEEDS_ACCESS permission or Admin role
 */
export const useNeedsAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('NEEDS_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

/**
 * ✅ QAQC TAB: Access control for QAQC tab in project detail
 * Requires QAQC_ACCESS permission or Admin role
 */
export const useQAQCAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('QAQC_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};

/**
 * ✅ CLOSING TAB: Access control for Closing tab in project detail
 * Requires CLOSING_ACCESS permission or Admin role
 * Feature flag: ENABLE_CLOSING_TAB
 */
export const useClosingAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const permissionCheck = useCheckPermission('CLOSING_ACCESS');
  
  return {
    data: isAdmin || permissionCheck.data,
    isLoading: isAdminLoading || permissionCheck.isLoading
  };
};
